import { mapGetters } from 'vuex';
import { getQRCode } from '@/utils/common.js';

export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      downAppVisible: false
    };
  },
  created() {
    if(this.isSignin) {
      this.$store.dispatch('getUnreadMessageNum');
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'messageUnreadNum',
      'isSignin'
    ])
  },
  methods: {
    // 获取下载二维码
    getQRCode,
    // 跳转到消息中心
    toMessageList() {
      console.log('消息中心注释掉了');
      // this.$router.push('/person-center/message-center/notice-list');
    }
  }
};
